<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="活动名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="8"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入活动名称,限制8个字' },
                ],
              },
            ]"
            placeholder="请输入活动名称"
          />
        </a-form-item>
        <a-form-item
          label="活动标题"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="10"
            v-decorator="[
              'title',
              {
                rules: [
                  { required: true, message: '请输入活动标题,限制10个字' },
                ],
              },
            ]"
            placeholder="请输入活动标题"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="活动类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="[
              'activityType',
              { rules: [{ required: true, message: '请选择活动类型' }] },
            ]"
            :triggerChange="true"
            dictCode="activity_type"
          />
        </a-form-item>
        <a-form-item
          label="活动规则类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['ruleType']"
            placeholder="请选择规则类型"
            @change="fieldValue"
          >
            <a-select-option
              v-for="(item, index) in ruleTypeList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="活动规则"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="showUpload"
        >
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="['ruleImg']"
          />
        </a-form-item>
        <a-form-item
          label="活动规则"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="showEditor"
        >
          <input type="textarea" v-show="false" v-decorator="['ruleText']" />
          <tinymce-editor
            :value="this.form.getFieldValue('ruleText')"
            @change="getMyValue"
          />
        </a-form-item>
        <a-form-item
          label="关联事件"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <!--<j-multi-select-tag placeholder="请选择关联事件" mode="multiple" v-decorator="['asoEvent']" :triggerChange="true" dictCode="event_type"/>
-->
          <a-select v-decorator="['asoEvent']" placeholder="请选择关联事件">
            <a-select-option
              v-for="(item, index) in eventList"
              :value="item.id"
              :key="index"
              >{{ item.eventName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="关联跑马灯"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-multi-select-tag
            placeholder="请选择关联跑马灯"
            mode="multiple"
            v-decorator="['asoHorseRace']"
            :triggerChange="true"
            dictCode="pmd_channel"
          />
        </a-form-item>
        <a-form-item
          label="关联Banner图"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['asoBanner']"
            placeholder="请选择关联Banner图"
          >
            <a-select-option
              v-for="(item, index) in bannerTypeList"
              :value="item.title"
              :key="index"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="活动启止时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-range-picker
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            v-decorator="['startEndTime']"
            style="width: 100%"
            :show-time="{
              hideDisabledOptions: true,
              defaultValue: [
                moment('00:00:00', 'HH:mm:ss'),
                moment('11:59:59', 'HH:mm:ss'),
              ],
            }"
          />
        </a-form-item>

        <!--<a-form-item label="活动维护图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-image-upload :isMultiple="false" v-decorator="['maintainImg']"></j-image-upload>
        </a-form-item>

        <a-form-item label="活动描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea type="text" :max-length="200" rows="4" v-decorator="['activityDescribe']" placeholder="请输入活动描述,限制200字"/>
        </a-form-item>-->
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';
import tinymceEditor from '@/components/tools/tinymceEditor';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'ActivityManageModal',
  components: {
    JMultiSelectTag,
    JDate,
    JImageUpload,
    tinymceEditor,
    UploadImage,
  },
  data() {
    return {
      fileList: '',
      bannerTypeList: [], //banner类型
      eventList: [], //事件列表

      showEditor: false,
      showUpload: false,
      editorOption: {
        modules: {
          toolbar: [
            [
              'bold',
              { header: 1 },
              { header: 2 },
              { color: [] },
              { font: [] },
              { size: ['small', false, 'large', 'huge'] },
              'italic',
              'underline',
              'strike',
            ], // toggled buttons
            [
              'blockquote',
              { indent: '-1' },
              { indent: '+1' },
              { align: [] },
              'clean',
            ],
          ],
        },
      },
      headers: {
        authorization: 'authorization-text',
      },
      ruleTypeList: [
        {
          name: '请选择',
          value: '0',
        },
        {
          name: '图片',
          value: '1',
        },
        {
          name: '文本',
          value: '2',
        },
      ],
      category: '0',
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/activity/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/activity/edit',
        typeList: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/list',
      },
    };
  },
  created() {},
  methods: {
    getMyValue(val) {
      this.form.setFieldsValue({
        ruleText: val,
      });
    },
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.id) {
        this.model.asoEvent = this.model.asoEvent.split(',');
      } else {
        this.model.asoEvent = [];
      }

      this.fileList = record.ruleImg;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          ruleImg: record.ruleImg
            ? process.env.VUE_APP_FILE_PATH + record.ruleImg
            : '',
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'title',
            'activityType',
            'activityDescribe',
            'ruleType',
            'maintainImg',
            'ruleText',
            'ruleImg',
            'status',
            'startEndTime',
            'asoEvent',
            'createTime',
            'updateTime',
            'asoHorseRace',
            'asoBanner'
          )
        );
      });

      if (this.model.startEndTime) {
        var ary = this.model.startEndTime.split('~');
        //formData.startEndTime[0].format('YYYY-MM-DD HH:mm:ss') + "~" + formData.startEndTime[1].format('YYYY-MM-DD HH:mm:ss')
        this.model.startEndTime = [
          moment(ary[0], 'YYYY-MM-DD HH:mm:ss'),
          moment(ary[1], 'YYYY-MM-DD HH:mm:ss'),
        ];
      }

      if (this.model.ruleType === '1') {
        this.showEditor = false;
        this.showUpload = true;
      } else if (this.model.ruleType === '2') {
        this.showEditor = true;
        this.showUpload = false;
      } else {
        this.showEditor = false;
        this.showUpload = false;
      }

      this.getTypeList();
      this.getEventList();
    },
    // 单个删除
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      var that = this;
      postAction(that.url.delete, { id: id }).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.loadData(1);
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    // 批量删除
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData(1);
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          let formData = Object.assign(this.model, values);
          if (formData.startEndTime) {
            formData.startEndTime =
              formData.startEndTime[0].format('YYYY-MM-DD HH:mm:ss') +
              '~' +
              formData.startEndTime[1].format('YYYY-MM-DD HH:mm:ss');
          }
          formData.asoEvent = formData.asoEvent.toString();
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'title',
          'activityType',
          'activityDescribe',
          'maintainImg',
          'ruleType',
          'ruleText',
          'ruleImg',
          'status',
          'startEndTime',
          'asoEvent',
          'createTime',
          'updateTime',
          'asoHorseRace',
          'asoBanner'
        )
      );
    },

    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
    },

    fieldValue(e) {
      if (e === '1') {
        this.showUpload = true;
        this.showEditor = false;
      } else if (e === '2') {
        this.showEditor = true;
        this.showUpload = false;
      } else {
        this.showEditor = false;
        this.showUpload = false;
      }
    },

    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },

    disabledDate(current) {
      return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
    },

    disabledRangeTime(_, type) {
      if (type === 'start') {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      };
    },

    getTypeList() {
      getAction(this.url.typeList, { category: this.category }).then((res) => {
        if (res.success) {
          this.bannerTypeList = res.result.records;
        }
      });
    },

    /**获取奖品列表*/
    getEventList() {
      let getUrl = process.env.VUE_APP_CMS_MARKETING + '/activity/getEventList';
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.eventList = res.result;
        }
      });
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        ruleImg: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
